import React, { Component } from 'react';
import { Button } from '@/components/ui/button';
import {
	DialogContent,
	Dialog,
	DialogTitle,
	DialogFooter,
	DialogClose,
	DialogDescription,
} from '@/components/ui/dialog';

class ErrorDialog extends Component {
	shouldShowBillingAction = () => {
		const { message } = this.props;
		if (typeof message !== 'string') {
			return false;
		}

		return /reactivate\s+your\s+account/i.test(message);
	};

	goToBilling = () => {
		window.location.href = '/settings/billing';
	};

	renderActions = () => {
		return (
			<>
				{this.shouldShowBillingAction() ? (
					<Button type="button" onClick={this.goToBilling}>
						Go to Billing
					</Button>
				) : null}
				<DialogClose asChild>
					<Button type="button" variant="ghost">
						Close
					</Button>
				</DialogClose>
			</>
		);
	};

	renderMessageLines() {
		const { message } = this.props;
		if (!message) return null;

		// Check if the message is not a string
		if (typeof message !== 'string') {
			return <div key={message}>{message}</div>;
		}

		// Split the message by newline characters
		const messageLines = message.split('\n');

		return messageLines.map((line) => <div key={line}>{line}</div>);
	}

	render() {
		return (
			<Dialog
				open={this.props.open}
				onOpenChange={this.props.handleCloseErrorDialog}
			>
				{/* Below xl the dialog can be short (a phone with the keyboard up),
				    so the text scrolls and the actions stay in view. On medium screens
				    the title scrolls with the message, inset clear of the close button.
				    Phones have a larger close button, so the title stays beside it and
				    only the message scrolls, starting far enough below the button's
				    touch area that a tap or drag there isn't taken as the button; if
				    even two lines don't fit, the card scrolls. A landscape phone with
				    the keyboard up (no status bar) gives the card almost all the space. */}
				<DialogContent
					mobileVariant="dialog"
					className="max-xl:flex max-xl:flex-col max-xl:kb-open:gap-3 max-xl:kb-open:py-4 max-md:kb-open:[@media(max-height:560px)]:max-h-[calc(var(--app-height)-0.5rem)]"
				>
					<div className="contents md:max-xl:flex md:max-xl:min-h-0 md:max-xl:flex-col md:max-xl:gap-4 md:max-xl:overflow-y-auto md:max-xl:overscroll-contain md:max-xl:kb-open:gap-3 md:max-xl:kb-open:mr-5">
						<DialogTitle className="max-md:shrink-0 max-md:pr-6 max-md:min-h-5 max-md:kb-open:min-h-8">
							{this.props.title}
						</DialogTitle>
						<DialogDescription className="max-md:min-h-8 max-md:overflow-y-auto max-md:overscroll-contain">
							<div className="flex flex-col">
								<div>{this.renderMessageLines()}</div>
							</div>
						</DialogDescription>
					</div>
					<DialogFooter className="max-xl:shrink-0">
						{this.renderActions()}
					</DialogFooter>
				</DialogContent>
			</Dialog>
		);
	}
}

export default ErrorDialog;
